import styled from 'styled-components';
import COLOR from 'constants/color';

export default styled.div`
  color: ${COLOR.midDarkGrey};
`;